import { defineStore } from 'pinia'

export const useUiStore = defineStore('ui', {
  state: () => ({
    openNavDropdown: '',
    mobileNavIsOpen: false,
  }),
  actions: {
    toggleNavDropdown(dropdownName: string | undefined = undefined) {
      this.openNavDropdown = dropdownName
    },
    toggleMobileNav() {
      this.mobileNavIsOpen = !this.mobileNavIsOpen
    },
    resetMobileNav() {
      this.mobileNavIsOpen = false
    },
  },
})
